import type { CardProps } from '@nextui-org/react';
import { Card } from '@nextui-org/react';
import React from 'react';

import { ContentTypesIcon, MarketPlaceIcon, OnChainIcon, UnifiedPlatformIcon } from '@/assets';

interface CardBaseProps {
  typeIcon: 'On-Chain Copyright' | 'Marketplace' | 'Diverse Content Types' | 'Unified Platform';
  className?: string;
}

const CardBase: React.FC<CardBaseProps & CardProps> = ({ typeIcon, className, ...props }) => {
  const renderItem = {
    'Unified Platform': {
      icon: <UnifiedPlatformIcon />,
      desc: 'Select AI models, create prompts, run prompts & obtain outputs all in one place',
    },
    'Diverse Content Types': {
      icon: <ContentTypesIcon />,
      desc: 'Images, Videos, Musics, 3D Models, House Designs, and more',
    },
    Marketplace: {
      icon: <MarketPlaceIcon />,
      desc: 'One-stop destination to showcase and transact AI-generated works',
    },
    'On-Chain Copyright': {
      icon: <OnChainIcon />,
      desc: 'Patented technology to detect on-chain infringement & ensure an immutable proof of origin & ownership for every creation',
    },
  };
  return (
    <Card
      isFooterBlurred
      radius="lg"
      className={`flex cursor-pointer items-center justify-center border-none ${className ?? ''}`}
      {...props}
    >
      <div className="flex flex-col items-center bg-transparent p-7 text-center">
        {renderItem[typeIcon].icon}
        <span className="mb-1 mt-2 text-18 font-bold">{typeIcon}</span>
        <span className="text-14 font-normal text-gray-500">{renderItem[typeIcon].desc}</span>
      </div>
    </Card>
  );
};

export default CardBase;
